import React from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { resetPassword, useAuth } from '../../Authentication/useAuth';
import './Signin.css';

const AdminLogin = () => {
	const { register, handleSubmit, watch, errors } = useForm();

	const auth = useAuth();

	const onSubmit = (data) => {
		if (data.email && data.password) {
			auth.signInAdmin(data.email, data.password);
		}
	};

	return (
			<div className="sign-up">
				<div className="container">
					<div className="text-center py-4">
						<Link to="/admin" class="text-info nav-link">
							<h2>Tanasafi Admin Panel</h2>
						</Link>
					</div>

					<form onSubmit={handleSubmit(onSubmit)} className="py-3">
						<h1 className="lead text-center py-3">Welcome back!</h1>
						{auth.user != null && <p className="text-danger"> {auth.user.error}</p>}

						<div className="form-group my-4">
							<input
								name="email"
								className="form-control"
								value="tanasafi@gmail.com"
								ref={register({ required: true })}
								placeholder="Tanasafi admin email..."
							/>
							{errors.email && <span className="error">Admin's email is required!</span>}
						</div>

						<div className="form-group my-4">
							<input
								type="password"
								name="password"
								value="Tanasafi@4321"
								className="form-control"
								ref={register({ required: true })}
								placeholder="Enter admin password..."
							/>
							{errors.password && <span className="error">Admin password is required!</span>}
						</div>
						<p className="forget-text" onClick={() => resetPassword(auth.user.email)}>I forgot my password🙄</p>

						<div className="form-group text-center">
							<button className="btn btn-primary w-25" type="submit">
								<b>Login</b>
							</button>
						</div>
					</form>
				</div>
			</div>
	);
};

export default AdminLogin;




